const LETTER_TYPES = "LETTER_TYPES";
const ORDERS_LIST = "ORDERS_LIST";
const ORDERS_FILTER = "ORDERS_FILTER";
const ORDER_TO_EDIT = "ORDER_TO_EDIT";
const UPDATE_ORDER = "UPDATE_ORDER";
const EDIT_NEW_ORDER = "EDIT_NEW_ORDER";
const DELIVERY_PRICES = "DELIVERY_PRICES";
const STATUS_TITLES = "STATUS_TITLES";
const ORDERS_IN_PROGRESS = "ORDERS_IN_PROGRESS";
const NEW_ORDERS_UNDER_MANAGER_PROGRESS = "NEW_ORDERS_UNDER_MANAGER_PROGRESS";

const state = {
  letterTypes: null,
  newUnderManagerProgress: {},
  ordersFilter: {},
  orders: [],
  ordersInProgress: {},
  orderToEdit: {},
  updateOrder: {},
  editNewOrder: {},
  deliveryPrices: null,
  statusTitles: {},
};

const getters = {
  letterTypes: state => state.letterTypes,
  ordersList: state => state.orders,
  ordersFilter: state => state.ordersFilter,
  orderToEdit: state => state.orderToEdit,
  updateOrder: state => state.updateOrder,
  editNewOrder: state => state.editNewOrder,
  deliveryPrices: state => state.deliveryPrices,
  statusTitles: state => state.statusTitles,
  ordersInProgress: state => state.ordersInProgress,
  newUnderManagerProgress: state => state.newUnderManagerProgress,
};

const actions = {
  setLetterTypes({dispatch, commit}, payload) {
    commit(LETTER_TYPES, payload);
  },
  setStatusTitles({dispatch, commit}, payload) {
    commit(STATUS_TITLES, payload);
  },
  setOrdersList({dispatch, commit}, payload) {
    commit(ORDERS_LIST, payload);
  },
  setOrdersFilter({dispatch, commit}, payload) {
    commit(ORDERS_FILTER, payload);
  },
  setOrderToEdit({dispatch, commit}, payload) {
    commit(ORDER_TO_EDIT, payload);
  },
  setUpdateOrder({dispatch, commit}, payload) {
    commit(UPDATE_ORDER, payload);
  },
  setEditNewOrder({dispatch, commit}, payload) {
    commit(EDIT_NEW_ORDER, payload);
  },
  setDeliveryPrices({dispatch, commit}, payload) {
    commit(DELIVERY_PRICES, payload);
  },
  setOrdersInProgress({dispatch, commit}, payload) {
    commit(ORDERS_IN_PROGRESS, payload);
  },
  setNewOrdersUnderManagerProgress({dispatch, commit}, payload) {
    commit(NEW_ORDERS_UNDER_MANAGER_PROGRESS, payload);
  },
};

const mutations = {
  [LETTER_TYPES](state, payload) {
    state.letterTypes = payload;
  },
  [ORDERS_LIST](state, payload) {
    state.orders = payload;
  },
  [ORDERS_FILTER](state, payload) {
    state.ordersFilter = payload;
  },
  [ORDER_TO_EDIT](state, payload) {
    state.orderToEdit = payload;
  },
  [UPDATE_ORDER](state, payload) {
    state.updateOrder = payload;
  },
  [EDIT_NEW_ORDER](state, payload) {
    state.editNewOrder = payload;
  },
  [STATUS_TITLES](state, payload) {
    state.statusTitles = payload;
  },
  [DELIVERY_PRICES](state, payload) {
    state.deliveryPrices = payload;
  },
  [ORDERS_IN_PROGRESS](state, payload) {
    state.ordersInProgress = payload;
  },
  [NEW_ORDERS_UNDER_MANAGER_PROGRESS](state, payload) {
    state.newUnderManagerProgress = payload;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
